import * as React from 'react'

import X from '@/components/icons/x.svg'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export interface InputProps extends React.ComponentProps<'input'> {
  onClear?: () => void
}

function Input({ className, type, onClear, ...props }: InputProps) {
  return (
    <>
      <input
        type={type}
        data-slot="input"
        className={cn(
          'placeholder:text-muted-foreground selection:bg-primary border-input flex h-12 w-full min-w-0 rounded-xl border bg-input px-3 text-base transition-[color] outline-none',
          'focus-visible:border-primary hover:border-primary',
          'disabled:cursor-not-allowed disabled:opacity-50 disabled:border-input',
          'aria-invalid:border-destructive',
          className,
        )}
        {...props}
      />
      {onClear && (
        <Button
          variant="icon"
          className="absolute rounded-full right-3 top-1/2 -translate-y-1/2 cursor-pointer bg-white/12"
          onClick={onClear}
        >
          <X className="size-2 fill-foreground" />
        </Button>
      )}
    </>
  )
}

export { Input }
